import { createApp } from 'vue'; 
import App from './App.vue' ;
import "../node_modules/vue-dawn-flow/dawn-flow.css"; 
import dawnFlow from "vue-dawn-flow" 

const app = createApp(App);
app.use(dawnFlow)
app.mount('#app')